type LogLevel = 'debug' | 'info' | 'warn' | 'error';

class Logger {
  private isDevelopment = import.meta.env.DEV;

  private getStyle(level: LogLevel): string {
    const styles = {
      debug: 'color: #888',
      info: 'color: #2196F3',
      warn: 'color: #FF9800',
      error: 'color: #F44336; font-weight: bold',
    };
    return styles[level];
  }

  private async sendToServer(_logEntry: any): Promise<void> {
    try {
      // В production можно отправлять критические ошибки на сервер
      // Пока оставляем заглушку для будущей реализации
      // await fetch('/api/logs', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(logEntry),
      // });
    } catch {
      // Игнорируем ошибки отправки логов
    }
  }

  private log(level: LogLevel, message: string, meta?: any): void {
    // В production не логируем debug
    if (!this.isDevelopment && level === 'debug') {
      return;
    }

    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level,
      message,
      ...meta,
    };

    // В development - красивый вывод в консоль
    if (this.isDevelopment) {
      const style = this.getStyle(level);
      const metaStr = meta ? JSON.stringify(meta, null, 2) : '';
      console.log(
        `%c[${timestamp}] ${level.toUpperCase()}`,
        style,
        message,
        metaStr || ''
      );
    } else {
      // В production - только ошибки и предупреждения
      if (level === 'error' || level === 'warn') {
        console[level](JSON.stringify(logEntry));
      }
    }

    // В production можно отправлять критические ошибки на сервер
    if (!this.isDevelopment && level === 'error') {
      this.sendToServer(logEntry);
    }
  }

  debug(message: string, meta?: any) {
    this.log('debug', message, meta);
  }

  info(message: string, meta?: any) {
    this.log('info', message, meta);
  }

  warn(message: string, meta?: any) {
    this.log('warn', message, meta);
  }

  error(message: string, error?: any, meta?: any) {
    this.log('error', message, {
      ...meta,
      error: error?.message || error,
      stack: error?.stack,
    });
  }
}

export const logger = new Logger();

